import { defineComponent as _defineComponent } from 'vue'
import Calendar from "@/components/ui/Calendar.vue";
  import { clickOutside as vClickOutside } from "@/directives/clickOutside";
  import {
    onMounted,
    ref,
    watch,
    computed,
  } from "vue";
  import dayjs from "dayjs";
  import customParseFormat from "dayjs/plugin/customParseFormat";
  import { formatDate } from "@/helpers/date";
  import isReportsRoute from "@/helpers/analytics/isReportsRoute";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    modelValue: { type: String, required: true },
    disabled: { required: true, type: Boolean, default: false },
    min: String,
    max: String,
    classField: String,
    position: {
      type: String,
      default() {
        return "left bottom";
      },
      validator(value: string) {
        const data = value.split(" ");

        return (
          data.length === 2 &&
          ["top", "left", "bottom", "right"].some((el) => data.includes(el))
        );
      },
    },
    showPlaceholder: { type: Boolean, default: true },
    customPlaceholder: { type: String, default: "Select Date" },
    showClearButton: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "clearRegistrationDate"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  dayjs.extend(customParseFormat);
  const props = __props;
  const emit = __emit;
  const showDatePicker = ref(false);
  const formatedDate = ref("");
  const invalidDate = ref(false);

  watch(
    () => props.modelValue,
    () => {
      if (props.modelValue) {
        formatedDate.value = dayjs(props.modelValue).format("DD/MM/YYYY");
      } else formatedDate.value = "";
    },
    { immediate: true }
  );
  watch(formatedDate, (newVal) => {
    if (newVal) {
      if (newVal.length === 10) {
        let dateParts = newVal.split("/");
        const currentDate = new Date(
          dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2]
        );

        if (
          !isNaN(currentDate.getTime()) &&
          dayjs(newVal, "DD/MM/YYYY", true).isValid()
        ) {
          invalidDate.value = false;

          if (props.min && new Date(props.min) > currentDate) {
            dateParts = dayjs(props.min).format("DD/MM/YYYY").split("/");
          }

          if (props.max && new Date(props.max) < currentDate) {
            dateParts = dayjs(props.max).format("DD/MM/YYYY").split("/");
          }

          formatedDate.value =
            dateParts.length > 1 ? dateParts.join("/") : `${dateParts[0]}`;
        } else {
          invalidDate.value = true;
        }
      }
    }
  });
  const closeDatePicker = (e: any) => {
    showDatePicker.value = false;

    if (formatedDate.value.length === 10) {
      const dateParts = formatedDate.value.split("/");

      dateSelected(dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2]);
    }
  };
  const datePicked = (date: string) => {
    formatedDate.value = dayjs(date).format("DD/MM/YYYY");
    dateSelected(date);
  };
  const dateSelected = (date: string) => {
    const currentDate = new Date(date);

    if (
      !isNaN(currentDate.getTime()) &&
      (formatedDate.value
        ? formatedDate.value === dayjs(currentDate).format("DD/MM/YYYY")
        : true)
    ) {
      emit("update:modelValue", date);
    } else {
      invalidDate.value = true;
    }

    showDatePicker.value = false;
  };

  function datePickerClick() {
    if (!props.disabled) {
      showDatePicker.value = true;
    }
  }

  const valueDatePicker = computed(() => {
    if (props.disabled && props.showPlaceholder) {
      return "Registration Date";
    }

    return formatedDate.value
      ? formatDate(dayjs(formatedDate.value, "DD/MM/YYYY"))
      : props.customPlaceholder;
  });

const __returned__ = { props, emit, showDatePicker, formatedDate, invalidDate, closeDatePicker, datePicked, dateSelected, datePickerClick, valueDatePicker, Calendar, get vClickOutside() { return vClickOutside }, onMounted, ref, watch, computed, get dayjs() { return dayjs }, get customParseFormat() { return customParseFormat }, get formatDate() { return formatDate }, get isReportsRoute() { return isReportsRoute } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})